import { Crown, Star, Gem } from "lucide-react";

/**
 * MemberBadge — reusable tier badge.
 * Used on profile panel hero, queue rows, search results, billing, waiting display.
 * Sizes: sm (default) | lg
 */
export function MemberBadge({ membership, size = "sm", className = "" }) {
  if (!membership || !membership.color_scheme) return null;
  const cs = membership.color_scheme || "gold";
  const label = (membership.badge_label || cs).toUpperCase();
  const IconMap = { silver: Star, gold: Crown, platinum: Gem };
  const Icon = IconMap[cs] || Crown;
  const cls = `mb-badge mb-${cs} ${size === "lg" ? "mb-badge-lg" : ""} ${className}`;
  return (
    <span className={cls} data-testid={`member-badge-${cs}`}>
      <Icon size={size === "lg" ? 12 : 10} />
      <span>{label}</span>
    </span>
  );
}

/**
 * TierChip — used in analytics for compact tier labels.
 */
export function TierChip({ scheme = "gold", children }) {
  return <span className={`tier-chip tier-chip-${scheme}`}>{children}</span>;
}
